import { Link } from "react-router";
import { EmptyState, VButton } from "@/components/ui";

export function NotFoundPage(): React.JSX.Element {
  return (
    <EmptyState
      title="Pagina niet gevonden"
      description="De pagina die je zocht bestaat niet of is verplaatst."
      action={
        <VButton asChild variant="primary">
          <Link to="/">Terug naar dashboard</Link>
        </VButton>
      }
    />
  );
}
